import { render, staticRenderFns } from "./OrganisationPaymentStep.vue?vue&type=template&id=0c65f2c2&"
import script from "./OrganisationPaymentStep.vue?vue&type=script&lang=js&"
export * from "./OrganisationPaymentStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports